import {
  RECOMMENDATION_WIDGET_FETCH,
  RECOMMENDATION_WIDGET_SUCCESS,
  RECOMMENDATION_WIDGET_FAILURE
} from '../../actions/shared/recommendationWidget';

const initialState = {
  PDP: {
    loading: false,
    widgetsData: null,
    error: null
  },
  PLP: {
    loading: false,
    widgetsData: null,
    error: null
  },
  Thankyou: {
    loading: false,
    widgetsData: null,
    error: null
  }
};

const recommendationWidgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECOMMENDATION_WIDGET_FETCH:
      return {
        ...state,
        [action.payload.pageType]: {
          ...state[action.payload.pageType],
          loading: true,
          error: null
        }
      };

    case RECOMMENDATION_WIDGET_SUCCESS:
      return {
        ...state,
        [action.payload.pageType]: {
          ...state[action.payload.pageType],
          loading: false,
          widgetsData: action.payload.widgetsData,
          error: null
        }
      };

    case RECOMMENDATION_WIDGET_FAILURE:
      return {
        ...state,
        [action.payload.pageType]: {
          ...state[action.payload.pageType],
          loading: false,
          widgetsData: null,
          error: action.payload.error
        }
      };

    default:
      return state;
  }
};

export default recommendationWidgetReducer;
